export default {
  'common.more': 'MORE',
  'common.fold': 'FOLD',
  'common.noData': 'No data',
  'common.success': 'Operation successfully',
  'common.docTitle': 'BREAKER PART (HEBEI) MACHINERY TECHNOLOGY CO., LTD.'
}
